export const validatePassword = (value: string) => {
  const regexUppercase = /^(?=.*[A-Z]).+$/;
  const regexLowercase = /^(?=.*[a-z]).+$/;
  const regexNumber = /^(?=.*[0-9]).+$/;
  const regexSpecial = /^(?=.*[$*&@#]).+$/;
  const length_char = value.length >= 8;

  return {
    upper_case: regexUppercase.test(value),
    lower_case: regexLowercase.test(value),
    number: regexNumber.test(value),
    special_char: regexSpecial.test(value),
    length_char,
  };
};
